

class ScopedMedia extends Charcoal.Admin.Widget {
    constructor(options) {
        super(options);
    }

    init() {
        this.$widget = this.element()
        this.$iframe = this.$widget.find('iframe.js-elfinder-iframe')
        super.init();
        this.setContentHeight()

        const $tab = this.$widget.closest('.js-group-tab')
        const tabId = $tab.attr('id')
        const $tabTrigger = $('.js-group-tabs[href="#'+tabId+'"]')

        if (this.$iframe.is(':visible')) {
            this.initIframe()
        } else {
            $tabTrigger.on('shown.bs.tab', () => this.initIframe())
        }
    }

    initIframe() {
        if (!this.$iframe.attr('src')) {
            this.$iframe.attr('src', this.$iframe.data('src'));
        }
    }

    reload(callback, with_data) {
        // No need to reload the iframe
        return this
    }

    setContentHeight() {
        const $pageHeader = $('.c-page-header')
        const height = window.innerHeight - $pageHeader[0].clientHeight - 130 + 'px';

        this.$iframe.css('height', height)
    }
}

Charcoal.Admin.Widget_Paj_Scoped_Media = ScopedMedia
